<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalParametro"
  aria-hidden="true" [config]="{ignoreBackdropClick: true, keyboard: false}">
  <div class="modal-dialog modal-lg">
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Parâmetro do Componente</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Ordem</mat-label>
                <input matInput formControlName="ordem" type="number" readonly />
              </mat-form-field>
            </div>
            <div class="col-md-9">
              <mat-form-field>
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nome" type="text" [maxlength]="parametroNomeMaxLength" readonly />
                <mat-hint align="end">Máx {{parametroNomeMaxLength}} caracteres</mat-hint>
                <mat-error *ngIf="form.get('nome')?.hasError('maxlength')">
                  O nome deve ter no máximo {{parametroNomeMaxLength}} caracteres.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Exemplo</mat-label>
                <input matInput formControlName="exemplo" type="text" maxlength="500" />
                <mat-hint align="end">Valor usado para gerar o exemplo JSON</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Preenchimento automático</mat-label>
                <mat-select formControlName="origem">
                  <mat-option value="">Sem preenchimento automático</mat-option>
                  <mat-option *ngIf="isOrigemLegada()" [value]="form.value.origem">
                    {{form.value.origem}} — Origem antiga ou não reconhecida
                  </mat-option>
                  <mat-optgroup *ngFor="let grupo of origemGrupos" [label]="grupo.nome">
                    <mat-option *ngFor="let opcao of grupo.opcoes" [value]="opcao.valor">
                      {{opcao.valor}} — {{opcao.descricao}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
                <mat-hint>{{getDescricaoOrigem()}}</mat-hint>
                <mat-error *ngIf="form.get('origem')?.hasError('required')">
                  Selecione a origem usada na confirmação de presença.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Descrição</mat-label>
                <textarea matInput formControlName="descricao" rows="3" maxlength="500"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="footer">
          <button mat-flat-button [disabled]="!form.valid" type="submit" color="primary" class="button-row">
            <span> Salvar</span>
          </button>
          <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
            <span> Cancelar</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
